import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import ComplaintList from "../components/ComplaintList";
import { useAuth } from "../context/AuthContext";
import { useComplaintModal } from "../context/ComplaintModalContext";
import { minhasDenuncias } from "../services/api";

export default function MinhasReclamacoesPage() {
  const { user } = useAuth();
  const { openComplaint } = useComplaintModal();
  const navigate = useNavigate();
  const [lista, setLista] = useState(null);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (!user) return;
    minhasDenuncias().then(setLista).catch((e) => setErro(e.message));
  }, [user]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8 pb-28 md:pb-8">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-text">Meus relatos</h1>
            <p className="text-gray-600 text-sm mt-1">Acompanhe o status, veja as respostas e avalie quando a empresa retornar.</p>
          </div>
          <button type="button" onClick={() => openComplaint()} className="rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold text-sm px-4 py-2">+ Novo relato</button>
        </div>

        {!user && <Aviso>Faça <Link to="/entrar" className="text-primary font-semibold">login</Link> para ver seus relatos.</Aviso>}
        {user?.tipo === 1 && <Aviso>Esta área é do candidato. Sua conta é de empresa — veja o <Link to="/painel" className="text-primary font-semibold">painel</Link>.</Aviso>}
        {erro && <p className="mt-4 text-red-600">{erro}</p>}
        {user?.tipo === 0 && !lista && !erro && <p className="mt-4 text-gray-500">Carregando...</p>}

        {user?.tipo === 0 && lista && (
          <div className="mt-5">
            <ComplaintList complaints={lista} onSelect={(d) => navigate(`/relato/${d.id}`)} />
          </div>
        )}
      </main>
    </div>
  );
}

function Aviso({ children }) {
  return <div className="mt-5 rounded-2xl border border-gray-200 bg-white p-8 text-center text-gray-600">{children}</div>;
}
